import React from "react";

const CrossIcon = ({ width = 8.752, height = 13.528 }) => {
  return (
    <>
      <svg
        width={width}
        height={height}
        id="cross"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 8.752 13.528"
      >
        <path
          id="Path_5"
          data-name="Path 5"
          d="M90.771,3.184h2.788V.4a.4.4,0,0,1,.4-.4h1.592a.4.4,0,0,1,.4.4V3.184h2.788a.4.4,0,0,1,.4.4V5.172a.4.4,0,0,1-.4.4H95.944v7.563a.4.4,0,0,1-.4.4H93.955a.4.4,0,0,1-.4-.4V5.569H90.771a.4.4,0,0,1-.4-.4V3.58A.4.4,0,0,1,90.771,3.184Z"
          transform="translate(-90.375)"
          fill="#1198ff"
        />
      </svg>
    </>
  );
};
export default CrossIcon;
